import { render, staticRenderFns } from "./sportselectdetail.vue?vue&type=template&id=2e0d7ae8&scoped=true&"
import script from "./sportselectdetail.vue?vue&type=script&lang=js&"
export * from "./sportselectdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0d7ae8",
  null
  
)

export default component.exports